import { Button, DatePicker, Input, Typography } from "antd";
import MainAppContainer from "element/MainAppContainer";
import { Helmet } from "react-helmet";
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { useEffect, useState } from 'react'
import request from "utils/request";
import DataPreview from "./DataPreview";
import conf from "conf";
import rupiah from "utils/rupiah";

dayjs.extend(customParseFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)

dayjs.locale('id')


export default function PrivateOMS() {

    const [date, setDate] = useState([dayjs(), dayjs()])
    const [loading, setLoading] = useState(false)
    const [orders, setOrders] = useState([])
    const [heavy, setHeavy] = useState(0)
    const [transfer, setTransfer] = useState(0)
    const [selecteds, setSelecteds] = useState([])
    const [markingCode, setMarkingCode] = useState('')

    const fetchData = () => {
        setLoading(true)
        request('/order/privateOms', 'POST', {
            from: date[0].unix(),
            to: date[1].unix()
        }).then(res => {
            setOrders(res)
            console.log(res)
        }).catch(err => {
            console.error(err.message || err)
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        fetchData()
    }, [date])

    return (
        <MainAppContainer name='private-oms'>
            <Helmet>
                <title>{conf.appName} - OMS</title>
            </Helmet>
            <DataPreview
                orders={orders.sort((a, b) => a.finished - b.finished)}
                onChanged={fetchData}
                onSelected={setSelecteds}
            />
            <div className="data-footer">
                <div className="left">
                    <DatePicker.RangePicker
                        className="range-pickerofdate"
                        placeholder={['Mulai tanggal', 'Sampai tanggal']}
                        format={'DD MMM YYYY'}
                        value={date}
                        onChange={setDate}
                        disabled={loading}
                    />
                </div>
                <div className="right">
                    <div className="form-control">
                        <Typography className="title">Marking Code</Typography>
                        <Input 
                            value={markingCode}
                            onChange={e => setMarkingCode(e.target.value)}
                            placeholder='Marking Code'
                            disabled={selecteds.length < 1}
                        />
                    </div>
                    <div className="form-control">
                        <Typography className="title">Berat</Typography>
                        <Input
                            placeholder='Berat'
                            value={rupiah.encode(heavy).replace('Rp', '').trim()}
                            onChange={e => {
                                setHeavy(rupiah.decode(e.target.value.split('.').join('')))
                            }}
                            disabled={selecteds.length < 1}
                            style={{
                                width: "100px"
                            }}
                        />
                    </div>
                    <div className="form-control">
                        <Typography className="title">Transfer</Typography>
                        <Input
                            placeholder="Transfer"
                            value={rupiah.encode(transfer)}
                            onChange={e => {
                                setTransfer(rupiah.decode(e.target.value.split('.').join('')))
                            }}
                            disabled={selecteds.length < 1}
                        />
                    </div>
                    <Button 
                        type='primary'
                        disabled={selecteds.length < 1}
                        onClick={() => {
                            request('/order/updateHeavyAndTransfer', "POST", {
                                orderIds: selecteds,
                                heavy,
                                transfer: transfer / selecteds.length,
                                markingCode
                            }).then(() => {
                                fetchData()
                            }).catch(err => console.error(err.message || err))
                        }}
                    >Simpan</Button>
                </div>
            </div>
        </MainAppContainer>
    )
}